import React from 'react';
import AppLayout from '../../layouts/app/AppLayout';
import './custom.scss';
import Services from '../home/services/homeServices';

import { translateThis } from '../../helpers/language.helper';




const InvestmentsPage = () => {
    // custom home functions here
    const pageName = "Investments";

    

    return (
        <AppLayout
            pageName={pageName}
        >

            <div className="main-content-wrapper investment-main-wrapper f-wrp">
                <div className='service-main-wrp f-wrp'>
                    <div className='service-main-container f-wrp'>
                        <div className='service-main-header f-wrp'>
                            <h1>{translateThis("Strategic")} <b>{translateThis("investment services")}</b></h1>
                            <p>{translateThis("We offer top-tier investment consultation and services, delivering the best deals and prices for sustainable growth across diverse industries.")}</p>
                        </div>

                        <div className='service-con-block f-wrp'>
                            <Services />
                        </div>

                    </div>
                </div>
            </div>
        </AppLayout>
    )
}

export default InvestmentsPage;